var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-row",class:[
  _vm.justify !== 'start' ? 'is-justify-' + _vm.justify : '',
  _vm.align !== 'top' ? 'is-align-' + _vm.align : '',
  {
    'el-row-flex': _vm.type === 'flex'
  }
],style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1775b708","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/row/src/row.vue
// module id = null
// module chunks = 